
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.107 3H2.889A2 2 0 00.995 5.091v11.045a2 2 0 001.894 2.091h5.9v2.139H7.513a.483.483 0 000 .962h9.239a.483.483 0 000-.962h-1.538v-2.139h5.894a2 2 0 001.893-2.091V5.091A2 2 0 0021.107 3zm-18.214.962h18.218a1.077 1.077 0 011.018 1.128v9.125H1.876V5.09a1.077 1.077 0 011.013-1.128zm11.443 16.4H9.663v-2.139h4.673zm6.771-3.1H2.889a1.078 1.078 0 01-1.017-1.128v-.958H22.12v.958a1.077 1.077 0 01-1.013 1.13z"}})])
          )
        }
      }
    